import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppConfig } from '../../AppConfig';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import { StepperComponent } from '../../components/quizzing/StepperComponent';

export class SectionProgress extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    return(
      <div className={css(Styles.outerContainer)}>
        <div className={css(Styles.container)}>
          <div className={css(Styles.sectionImgConatiner)}>
            <img
              src={this.props.data.image}
              className={css(Styles.sectionImg)}
            />
          </div>
          <StepperComponent
            handleStep={this.props.handleStep}
            activeStep={this.props.activeStep}
            data={this.props.data.subsections}
          />
        </div>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  outerContainer: {
    display: 'flex',
    margin: '20px 0px',
    '@media (max-width: 767px)': {
      flexDirection: 'column',
    },
    '@media(min-width: 768px) and (max-width: 1024px)': {
      flexDirection: 'column',
    },
  },
  container: {
    display: 'flex',
    flex: 1,
    '@media (max-width: 1024px)': {
      flexDirection: 'column',
      alignItems: 'center'
    }
  },
  sectionImgConatiner: {
    display: 'flex',
    alignItems: 'center',
    width: 200,
    height: 200,
    '@media (max-width: 767px)': {
      width: 200,
      height: 200,
    },
  },
  sectionImg: {
    maxWidth: '100%',
    maxHeight: '100%'
  },
})


// WEBPACK FOOTER //
// ./src/components/quizzing/SectionProgress.js